<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isVisibleUserRoleForm ||
    isShowClaimAuditPage ||
    isShowRolesClone ||
    pageConfig?.isVisibleAuditPage
      ? 'd-none'
      : ''
  "
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Audit btns ---------------->
  <div custom-content>
    <div class="row">
      <!-- roles -->
      <section class="md:tw-w-1/2 tw-pt-5">
        <app-dynamic-table
          [config]="pageConfig?.tableConfig"
          [loading]="pageConfig?.loading"
          [isEmpty]="pageConfig?.isEmpty"
          [hasError]="pageConfig?.hasError"
          (sortObject)="getSortItems($event)"
          (comparisonObjects)="getComparisonObjects($event)"
          (pageNumber)="changePageNumber($event)"
          (pageSize)="changePageSize($event)"
          (onSelectAll)="onSelectAll($event)"
        >
          <ng-container
            table-body
            *ngIf="(items$ | async) && !pageConfig.loading"
          >
            <ng-container
              *ngFor="let item of items$ | async; let index = index"
            >
              <tr
                #tr
                [id]="'role-' + item.id"
                [class.role-active]="roleIdSelected == item.id"
              >
                <!-- index -->
                <td
                  (click)="onSelect(item)"
                  class="tw-cursor-pointer tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center"
                >
                  {{ paginationModel?.firstIndex + index }}
                </td>

                <!-- name -->
                <td (click)="onSelect(item)" class="tw-cursor-pointer">
                  <td-value copyToClipboard [value]="item?.name"></td-value>
                </td>

                <!-- created -->
                <td (click)="onSelect(item)" class="tw-cursor-pointer">
                  <td-value type="dateTime" [value]="item?.created"></td-value>
                </td>

                <!------------------------------- operations -------------------------------->

                <td class="sticky-td">
                  <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>


                  <mat-menu #menu="matMenu" xPosition="before">
                    <!-- clone button -->
                    <div app-menu-btn icon="mdi mdi-content-copy mdi-20px" color="blue" [title]="pageVocabs + 'cloneRole'"
                      (click)="onClone(item.id)"></div>
                  
                    <!-- edit button -->
                    <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>
                  
                    <!-- delete button -->
                    <div app-menu-btn icon="delete" (click)="onDelete(item.id, item.name, true)">
                    </div>
                  </mat-menu>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </app-dynamic-table>
      </section>

      <!-- organizations -->
      <section class="md:tw-w-1/2">
        <fieldset class="tw-h-full tw-relative">
          <legend class="tw-text-gray-700 tw-px-4">
            {{ "common.organizations" | translate }}
          </legend>

          <app-role-organizations
            [organizations]="roleOrganizations"
            [loading]="pageConfig.loading"
            (selectedOrganization)="getSelectedOrganization($event)"
          ></app-role-organizations>

          <div
            class="tw-flex-center role-organizations-loading"
            *ngIf="pageConfig.loading"
          >
            <div class="spinner-border text-navyBlue" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span class="text-navyBlue tw-text-lg tw-font-medium tw-mx-2">{{
              "common.loading" | translate
            }}</span>
          </div>
        </fieldset>
      </section>
    </div>
  </div>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-roles-form
    page-form
    [formPageConfig]="formPageConfig"
    [menusClaims]="menusClaims"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-roles-form>
</ng-container>

<!-- roles clone form -->
<ng-container *ngIf="isShowRolesClone">
  <app-roles-clone-form
    page-form
    [roleId]="roleIdSelected"
    (closeFormPage)="getRolesCloneFormResponse($event)"
  >
  </app-roles-clone-form>
</ng-container>

<!-- role users -->
<ng-container *ngIf="isVisibleUserRoleForm">
  <app-role-users-form
    [title]="pageVocabs + 'userRoles.title'"
    [roleId]="userRoleId"
    [users]="roleUsersSelected"
    [organizationId]="userRoleOrganizationId"
    (closeFormPage)="this.isVisibleUserRoleForm = false"
  >
  </app-role-users-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------------------------------Claim Audit ---------------->
<ng-container *ngIf="isShowClaimAuditPage">
  <app-audit
    [service]="claimsService"
    methodName="claimsGetCliamsAudit"
    (hidePage)="isShowClaimAuditPage = false"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
